import { render, staticRenderFns } from "./JointContactInformation.vue?vue&type=template&id=af249e54"
import script from "./JointContactInformation.vue?vue&type=script&lang=js"
export * from "./JointContactInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports